export const passwordToggleSx = {
  border: 0,
  bgcolor: "transparent",
  color: "text.secondary",
  boxShadow: "none",
  "&:hover, &:focus-visible": {
    bgcolor: "transparent",
    color: "#9a7000",
    boxShadow: "none",
  },
};
